import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { useAuth } from '../../auth/Auth';
import Avatar from '../../common/Avatar';
import RoundButton from '../../common/RoundButton';
import MyBadge from '../../common/MyBadge';
import Challenges from '../../../assets/images/flag-Challenges.svg';
import Creations from '../../../assets/images/star-Creations.svg';
import binkyIcon from '../../../assets/images/icon-binky-selected.svg';
import Lock from '../../../assets/images/Lock.svg';
import DreamCampTicket from '../../../assets/images/dream-camp-ticket.svg';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import {
  GUARDIAN_SETTINGS_ROUTE,
  MY_ROOM_ROUTE,
  CAPTAIN_ROUTE,
  PAYMENT_ROUTE,
  SPECIAL_CAMP_LIST,
} from '../../../constants/routes.constants';
import { NORMAL_TYPE } from '../../../constants/avatarType.constants';
import ChildActionButtons from './ChildActionButtons';
import Notification from './Notification';
import { specialCampViewModel } from '../special_camp/special.camp.viewmodel';
import visitChildPopupIcon from '../../../assets/images/visit-child-popup.svg';
import AccountVerification from '../../common/AccountVerification';
import './css/kid.management.scss';
import KidSelectbox from './KidSelectBox';
import AddChild from '../onboarding/signup_popups/AddChild';
import RegisterFirstChild from '../onboarding/signup_popups/RegisterFirstChild';
import KidUpgradedModal from '../onboarding/signup_popups/KidUpgradedModal';
import TimeToUpgradeModal from '../onboarding/signup_popups/TimeToUpgradeModal';
import '../../mui/binkiesCompliments.css';
import KidInterests from '../../mui/KidInterests';
import DashboardInsights from './DashboardInsights';
import MoodTracker from '../../mui/DateCalendar';
import ChildRegistration from '../onboarding/signup_popups/ChildRegistration';
import { isPayByCamp } from '../../../utils/utils';
import GuardianTour from '../school/camp_tour/GuardianTour';
import { useRecoilState } from 'recoil';
import { currentStepsAtom, stepsEnabledAtom } from '../../../atoms/camp.atom';
import GuardianTourModal from '../school/camp_tour/GuardianTourModal';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';

const theme = createTheme({
  palette: {
    background: {
      paper: '#fff',
    },
  },
});

const KidManagement = ({ handleShowModal }) => {
  const { guardian, fetchAPI, getGuardianDependents, saveDependentUser } =
    useAuth();
  const history = useHistory();
  const [available, setAvailable] = useState(false);
  const [specialCamp, setSpecialCamp] = useState({});
  const [isExistingUser, setIsExistingUser] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showAddChild, setShowAddChild] = useState(false);
  const [showRegisterFirstChildModal, setShowRegisterFirstChildModal] =
    useState(false);
  const [showTimeToUpgradePopup, setShowTimeToUpgradePopup] = useState(false);
  const [upgradeType, setUpgradeType] = useState('both');
  const [selectedDependent, setSelectedDependent] = useState(
    localStorage.getItem('set_dependent')
      ? guardian.dependents[
          guardian.dependents.findIndex(
            (obj) => obj.username === localStorage.getItem('set_dependent')
          )
        ]
      : guardian.dependents[0]
      ? guardian.dependents[0]
      : ''
  );
  const accountVerificationRef = useRef();
  const [showDetailedInsights, setShowDetailedInsights] = useState(false);
  const [showAddUsernameModal, setShowAddUsernameModal] = useState(false);
  const [currentStep, setCurrentStep] = useRecoilState(currentStepsAtom); // Track the current step
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const [showTourModal, setShowTourModal] = useState(false);

  const getUpcomingSpecialCamp = (camp_id) => {
    fetchAPI(specialCampViewModel.getUpcomingSpecialCamp, camp_id)
      .then((res) => {
        if (res === '') {
          setAvailable(false);
          setSpecialCamp({});
          return;
        } else {
          setAvailable(true);
          setSpecialCamp(res);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleAddKidClick = (e) => {
    setShowAddChild(true);
  };
  const handleKidRegistration = (e) => {
    handleShowModal(guardian.dependents[0]);
  };

  const myRoom = () => {
    saveDependentUser(selectedDependent);
    history.push({
      pathname: MY_ROOM_ROUTE,
    });
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (
      selectedDependent?.profile?.tribe_request_status === 'invited_by_camp'
    ) {
      setShowAddUsernameModal(true);
    } else {
      if (selectedDependent?.id) {
        let camp_id = selectedDependent?.school_details?.id
          ? selectedDependent?.school_details?.id
          : '';
        getUpcomingSpecialCamp(camp_id);
      }
      if (
        guardian.dependents.length &&
        guardian.dependents[0].profile &&
        !guardian.dependents[0].profile.nick_name &&
        !guardian.dependents[0].profile?.is_activated
      ) {
        handleKidRegistration();
      } else if (
        guardian.dependents.length &&
        location?.state?.from === 'verified'
      ) {
        accountVerificationRef.current.handleOpen();
      }
      if (
        guardian.dependents.length &&
        selectedDependent?.profile &&
        !selectedDependent?.profile?.is_activated
      ) {
        if (history?.location?.state?.from !== 'payment') {
          const currentState = history.location.state || {};
          const newState = { ...currentState, dependent: selectedDependent };
          history.replace({ ...history.location, state: newState });
          accountVerificationRef.current.handleOpen();
        } else {
          setTimeout(() => {
            const currentState = history.location.state || {};
            const newState = { ...currentState, from: '' };
            history.replace({ ...history.location, state: newState });
          }, [1000]);
        }
      }
      if (
        selectedDependent &&
        !selectedDependent?.subscriptions &&
        selectedDependent?.profile?.one_time_plan === 'Emeralites'
      ) {
        if (
          selectedDependent?.dependent_creation_count > 19 ||
          selectedDependent?.dependent_challenge_count > 19
        ) {
          setShowTimeToUpgradePopup(true);
          if (
            selectedDependent?.dependent_creation_count > 19 &&
            selectedDependent?.dependent_challenge_count > 19
          ) {
            setUpgradeType('both');
          } else {
            if (selectedDependent?.dependent_creation_count > 19) {
              setUpgradeType('creation');
            } else {
              if (selectedDependent?.dependent_challenge_count > 19) {
                setUpgradeType('challenge');
              }
            }
          }
        }
      }
    }
    setIsExistingUser(
      guardian.dependents.length === 1 &&
        guardian.dependents[0].subscriptions === '' &&
        guardian.relationship_to_kid === ''
    );
  }, [selectedDependent]);

  useEffect(() => {}, [specialCamp]);

  useEffect(() => {
    if (!guardian?.dependents.length) setShowRegisterFirstChildModal(true);
  }, [guardian]);

  const handleClick = (e) => {
    if (!selectedDependent?.profile?.is_activated) {
      accountVerificationRef.current.handleOpen();
    } else {
      history.push({
        pathname: SPECIAL_CAMP_LIST,
        state: {
          dependent: selectedDependent,
        },
      });
    }
    // const dom = e.target;
    // const isSeedlings = dom.dataset.isseedlings === 'true';
    // const isAttend = dom.dataset.isattend === 'true';
    // const isPurchased = Number(dom.dataset.specialcampid) === specialCamp?.id;
    // const isFreeForSeedling = dom.dataset.isfreeforseedling === 'true';
    // const dependent = getGuardianDependents([
    //   parseInt(dom.dataset.dependentid, 10),
    // ]);
    // if (!dependent[0]?.profile?.is_activated) {
    //   return;
    // }
    // if (!available) {
    //   return;
    // } else if (isSeedlings && isPurchased) {
    //   // console.log('purchased routine');
    //   history.push({
    //     pathname: `${GUARDIAN_SETTINGS_ROUTE}/special-camp`,
    //     state: { specialCamp, dependent, purchased: 'attendance' },
    //     // state: { specialCamp, dependent, purchased: 'purchased' },
    //   });
    // } else if (isSeedlings && isFreeForSeedling) {
    //   history.push({
    //     pathname: `${GUARDIAN_SETTINGS_ROUTE}/special-camp`,
    //     state: { specialCamp, dependent, purchased: 'attendance' },
    //   });
    // } else if (isSeedlings && !isPurchased) {
    //   history.push({
    //     pathname: `${GUARDIAN_SETTINGS_ROUTE}/special-camp`,
    //     state: { specialCamp, dependent, purchased: 'purchase' },
    //   });
    // } else if (!isSeedlings) {
    //   history.push({
    //     pathname: `${GUARDIAN_SETTINGS_ROUTE}/special-camp`,
    //     state: { specialCamp, dependent, purchased: 'attendance' },
    //   });
    // }
  };

  const showSpecialCamp = (dependent) => {
    // const isSeedlings = dependent?.subscriptions.nickname === 'Seedlings';
    const isSeedlings = dependent?.profile?.is_activated
      ? !dependent?.subscriptions
        ? true
        : dependent?.subscriptions?.nickname === 'Seedlings'
        ? true
        : false
      : false;
    // const isSeedlings = false;
    const isVerified = dependent?.profile?.is_activated;
    const isPurchased = dependent?.special_camp?.purchased;
    const isAttend = dependent?.special_camp?.attend === 'YES';
    const specialCampId = dependent?.special_camp?.special_camp_id;
    const isFreeForSeedling = specialCamp?.is_seedling;
    const specialCampImage = isVerified
      ? isSeedlings
        ? available
          ? isFreeForSeedling
            ? isAttend && specialCampId === specialCamp?.id
              ? 'attend'
              : 'cyan-sc'
            : isAttend && isPurchased
            ? 'attend'
            : isPurchased &&
              specialCamp?.id === dependent?.special_camp?.special_camp_id
            ? 'cyan-sc'
            : 'yellow-sc'
          : 'yellow-sc-coming-soon'
        : available
        ? isAttend && specialCampId === specialCamp?.id
          ? 'attend'
          : 'cyan-sc'
        : // : isPurchased && specialCamp?.id === dependent?.special_camp?.special_camp_id
          //   ? 'cyan-sc'
          //   : 'yellow-sc-coming-soon'
          'cyan-sc-coming-soon'
      : 'yellow-sc-coming-soon';

    return (
      <Col
        className={`col-xl-4 special-camp-column dream`}
        data-isseedlings={isSeedlings}
        data-isattend={isAttend}
        data-ispurchased={isPurchased}
        data-dependentid={dependent?.id}
        data-specialCampId={specialCampId}
        data-isfreeforseedling={isFreeForSeedling}
        onClick={handleClick}
      ></Col>
    );
  };

  const handleUpgradeClick = () => {
    history.push({
      pathname: `${PAYMENT_ROUTE}`,
      state: {
        dependent: JSON.stringify(selectedDependent),
        type: selectedDependent?.profile?.is_activated ? 'edit' : 'activate',
      },
    });
  };

  const currentDate = new Date();

  const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  const handleTour = () => {
    setShowTourModal(!showTourModal);
  };

  return (
    <Row className="middle-section guardian-row-box">
      {stepsEnabled && <GuardianTour />}
      <Row className="header-row">
        <Col className="welcome mb-3">{`Welcome ${guardian?.first_name}`}</Col>
        <Col className="add-kid">
          <RoundButton
            type="button"
            label="Start tour"
            className="transparent-button d-none d-sm-block add-kid-btn"
            onClick={handleTour}
          />
          <KidSelectbox
            tagList={guardian?.dependents}
            selectedFilter=""
            selectedDependent={selectedDependent}
            setSelectedDependent={setSelectedDependent}
            selected=""
            showListWithTag=""
          />
          <RoundButton
            type="button"
            label="Add a kid"
            className="transparent-button d-none d-sm-block add-kid-btn"
            id="guardian-step-nine"
            onClick={handleAddKidClick}
          />
          <RoundButton
            type="button"
            label="+ Kid"
            className="transparent-button d-block d-sm-none add-kid-btn"
            id="guardian-step-nine"
            onClick={handleAddKidClick}
          />
          <Tooltip
            title="Start tour"
            arrow
            disableFocusListener
            placement="bottom-start"
          >
            <InfoOutlinedIcon
              className="d-block d-sm-none"
              sx={{
                color: '#fff',
                marginLeft: '20px',
                height: '30px',
                width: '30px',
              }}
              onClick={handleTour}
            />
          </Tooltip>
        </Col>
      </Row>
      <Modal show={isOpen} onHide={closeModal} className="modal-share">
        <Modal.Header closeButton>
          <Modal.Title>
            <div>
              <img className="" src={visitChildPopupIcon} alt="" />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>
            You can now share your child's creations with friends and family'
          </h4>
          <Button className="btn-theme font-weight-bold" onClick={myRoom}>
            Share
          </Button>
        </Modal.Body>
      </Modal>
      <Row className="kid-box vertical-height activated insights-dashboard">
        <Col className="avatar-wrapper ">
          <Avatar
            type={NORMAL_TYPE}
            key={selectedDependent?.username}
            userProfileUrl={selectedDependent?.profile?.picture_url}
            userName={selectedDependent?.username}
            firstName={selectedDependent?.first_name}
            lastName={selectedDependent?.last_name}
            taletreeFriend={selectedDependent?.profile?.taletree_friend}
            subscription={selectedDependent?.subscriptions}
            activated={selectedDependent?.profile?.is_activated}
            id={selectedDependent?.id}
            size={120}
            profile={selectedDependent?.profile}
            school_details={selectedDependent?.school_details}
          />
          <Row className="badge-wrapper kid-dashboard-manage">
            <MyBadge
              icon={Creations}
              className="first-badge"
              count={selectedDependent?.dependent_creation_count}
              title={'Creations'}
              isEmeralites={
                !selectedDependent?.subscriptions &&
                selectedDependent?.is_verified &&
                selectedDependent?.profile?.one_time_plan === 'Emeralites'
                  ? true
                  : false
              }
            />
            <MyBadge
              icon={Challenges}
              count={selectedDependent?.dependent_challenge_count}
              title={'Challenges'}
              isEmeralites={
                !selectedDependent?.subscriptions &&
                selectedDependent?.is_verified &&
                selectedDependent?.profile?.one_time_plan === 'Emeralites'
                  ? true
                  : false
              }
            />
            <MyBadge
              icon={binkyIcon}
              count={selectedDependent?.binky_count}
              title={'Binkies'}
            />
          </Row>
          <div></div>
        </Col>
        {showSpecialCamp(selectedDependent)}
        <Col className="command-wrapper">
          <ChildActionButtons dependent={selectedDependent} />
        </Col>
        <Row className="myroom-info-wrapper slider-cards">
          <Col
            className="myroom-collapse insights-soon most-complimented-creation mood-creation"
            style={{ padding: '0px' }}
          >
            {selectedDependent?.subscriptions?.subscription_id ||
            isPayByCamp(selectedDependent?.school_details?.pay_by) ? (
              selectedDependent?.profile?.tribe_request_status !==
              'requested_by_guardian' ? (
                <>
                  <ThemeProvider theme={theme}>
                    <KidInterests
                      dependent={selectedDependent}
                      showDetailedInsights={showDetailedInsights}
                      setShowDetailedInsights={setShowDetailedInsights}
                    />
                  </ThemeProvider>
                </>
              ) : selectedDependent?.subscriptions?.subscription_id ? (
                <>
                  <ThemeProvider theme={theme}>
                    <KidInterests
                      dependent={selectedDependent}
                      showDetailedInsights={showDetailedInsights}
                      setShowDetailedInsights={setShowDetailedInsights}
                    />
                  </ThemeProvider>
                </>
              ) : stepsEnabled ? (
                <>
                  <ThemeProvider theme={theme}>
                    <KidInterests
                      dependent={selectedDependent}
                      showDetailedInsights={showDetailedInsights}
                      setShowDetailedInsights={setShowDetailedInsights}
                    />
                  </ThemeProvider>
                </>
              ) : (
                <>
                  <h3 className="insights-h3">Insights</h3>
                  <div className="insights-img">
                    <img className="" src={Lock} alt="" />
                    <h4>
                      Unlock{' '}
                      <span className="insights-span"> parental insights </span>
                      <br />
                      each month on your kids progress.
                    </h4>
                    <button
                      className="subscription-button Upgrade gred-btn"
                      onClick={handleUpgradeClick}
                    >
                      Upgrade to Seedlings
                    </button>
                  </div>
                </>
              )
            ) : stepsEnabled ? (
              <>
                <ThemeProvider theme={theme}>
                  <KidInterests
                    dependent={selectedDependent}
                    showDetailedInsights={showDetailedInsights}
                    setShowDetailedInsights={setShowDetailedInsights}
                  />
                </ThemeProvider>
              </>
            ) : (
              <>
                <h3 className="insights-h3">Insights</h3>
                <div className="insights-img">
                  <img className="" src={Lock} alt="" />
                  <h4>
                    Unlock{' '}
                    <span className="insights-span"> parental insights </span>
                    <br />
                    each month on your kids progress.
                  </h4>
                  <button
                    className="subscription-button Upgrade gred-btn"
                    onClick={handleUpgradeClick}
                  >
                    Upgrade to Seedlings
                  </button>
                </div>
              </>
            )}
          </Col>
        </Row>
        {selectedDependent?.profile?.is_activated ? (
          selectedDependent?.subscriptions?.subscription_id ||
          isPayByCamp(selectedDependent?.school_details?.pay_by) ? (
            selectedDependent?.profile?.tribe_request_status !==
            'requested_by_guardian' ? (
              <ThemeProvider theme={theme}>
                <DashboardInsights
                  selectedDependent={selectedDependent}
                  showDetailedInsights={showDetailedInsights}
                />
                <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
                  <Col className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                    <MoodTracker
                      type="Comment"
                      cardClass={'short_second_card'}
                      dependent={selectedDependent}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            ) : selectedDependent?.subscriptions?.subscription_id ? (
              <ThemeProvider theme={theme}>
                <DashboardInsights
                  selectedDependent={selectedDependent}
                  showDetailedInsights={showDetailedInsights}
                />
                <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
                  <Col className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                    <MoodTracker
                      type="Comment"
                      cardClass={'short_second_card'}
                      dependent={selectedDependent}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            ) : stepsEnabled ? (
              <ThemeProvider theme={theme}>
                <DashboardInsights
                  selectedDependent={selectedDependent}
                  showDetailedInsights={showDetailedInsights}
                />
                <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
                  <Col className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                    <MoodTracker
                      type="Comment"
                      cardClass={'short_second_card'}
                      dependent={selectedDependent}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            ) : (
              ''
            )
          ) : (
            ''
          )
        ) : stepsEnabled ? (
          <ThemeProvider theme={theme}>
            <DashboardInsights
              selectedDependent={selectedDependent}
              showDetailedInsights={showDetailedInsights}
            />
            <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
              <Col className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                <MoodTracker
                  type="Comment"
                  cardClass={'short_second_card'}
                  dependent={selectedDependent}
                />
              </Col>
            </Row>
          </ThemeProvider>
        ) : (
          ''
        )}
      </Row>
      {/* {isExistingUser ? <Notification /> : ''} */}
      {showAddUsernameModal && (
        <ChildRegistration
          showModal={showAddUsernameModal}
          setShowModal={setShowAddUsernameModal}
          childData={guardian?.dependents[0]}
          type="invited"
        />
      )}
      <RegisterFirstChild
        showModal={showRegisterFirstChildModal}
        setShowModal={setShowRegisterFirstChildModal}
      />
      <AddChild showModal={showAddChild} setShowModal={setShowAddChild} />
      <AccountVerification
        id={selectedDependent?.id}
        firstName={selectedDependent?.first_name}
        ref={accountVerificationRef}
        dependent={selectedDependent}
      />
      {history?.location?.state?.isUpgrade && <KidUpgradedModal />}
      {showTimeToUpgradePopup && (
        <TimeToUpgradeModal
          showPopup={showTimeToUpgradePopup}
          setShowPopup={setShowTimeToUpgradePopup}
          upgradeType={upgradeType}
        />
      )}
      {showTourModal && (
        <GuardianTourModal
          showModal={showTourModal}
          setShowModal={setShowTourModal}
        />
      )}
    </Row>
  );
};

export default KidManagement;
